
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,

		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1',
        paginationTypeAdvanced: true,
        loadPreviousType: 'infinite',
        activeLoadPreviousPage: true
	},
};

(function() {
	BoostPFS.inject(this);

	function escapeHtml(value) {
		return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
		});
	}

	function normalizeFilterLabels() {
		document.querySelectorAll('.boost-pfs-filter-option-type .boost-pfs-filter-option-value, .refine-by-value').forEach(function(label) {
			var original = label.textContent;
			var normalized = original;
			if (label.classList.contains('refine-by-value')) {
				normalized = normalized.replace(/^View All Floor Lamps$/, 'Outdoor Floor Lamps');
			}
			normalized = normalized.replace(/^(?:View |All )+/, '');
			if (label.classList.contains('refine-by-value')) normalized = normalized.replace(/^Portable$/, 'Portable Lamps');
			if (normalized !== original) label.textContent = normalized;
		});
	}


	function prepareShopifyData(data) {

		soldOut = !data.available;
		onSale = data.compare_at_price_min > data.price_min;
		priceVaries = data.price_min != data.price_max;

		images = data.images_info;

		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}



	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;

		var itemHtml = boostPFSTemplate.productGridItemHtml;

		data = prepareShopifyData(data);


		itemHtml = itemHtml.replace(/{{itemLabels}}/g, function() { return buildLabels(data); });


		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row );


		itemHtml = itemHtml.replace(/{{itemImages}}/g, function() { return buildImage(data, images); });


		itemHtml = itemHtml.replace(/{{itemInfo}}/g, function() { return buildInfo(data, index); });


		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, function() { return escapeHtml(Utils.buildProductItemUrl(data)); });

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}

		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};



	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images) {
		var htmlImg = '';
		var imageAlt = escapeHtml(data.title);
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '">';
			
			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
			
			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + escapeHtml(thumbUrl) + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + imageAlt + '" width="' + images[1].width + '" height="' + images[1].height + '" data-image-id="' + images[1].id + '">';
			}
			
			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + escapeHtml(thumbUrl_main) + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + imageAlt + '" width="' + images[0].width + '" height="' + images[0].height + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image" src="' + escapeHtml(Utils.optimizeImage(images[0]['src'], '600x')) + '" alt="' + imageAlt + '" width="' + images[0].width + '" height="' + images[0].height + '">';
			htmlImg += '</noscript>';
			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}
			
			if (supported_sizes == '') supported_sizes = image.width;
			
			if(!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
		if (onSale) {
			html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Shopify.formatMoney((data.price_min * 100), window.theme.moneyWithCurrencyFormat) + '</span> ';
			html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney((data.compare_at_price_min * 100), window.theme.moneyWithCurrencyFormat) + '</span>';
		} else {
			if (priceVaries) {
				html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Shopify.formatMoney((data.price_min * 100), window.theme.moneyWithCurrencyFormat)).replace(/{{max_price}}/g, Shopify.formatMoney((data.price_max * 100), window.theme.moneyWithCurrencyFormat)) + '</span>';
			} else {
				html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney((data.price_min * 100), window.theme.moneyWithCurrencyFormat) + '</span>';
			}
		}
if (document.querySelector('.list-view-show') !== null) {

      html += '<p class="ProductItem__Free-shipping Heading custom-col-free">+ Free Shipping</p>'
                           } else {
                              html += '<p class="ProductItem__Free-shipping Heading hide">+ Free Shipping</p>'
                           }
		html += '</div>';
		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		var bestSeller = ""
		var iconic = ""
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if(tag == 'badge_iconic'){
					iconic = '<span class="ProductItem__Label Heading Text--subdued gray__label"> Iconic </span>';
					break;
				} else if(tag == 'best-sellers'){
					bestSeller = '<span class="ProductItem__Label Heading Text--subdued gray__label"> Best Seller </span>';
				}
				if (tag.indexOf('__label') != -1) {
					
				product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + escapeHtml(tag.split('__label:')[1]) + '</span>';
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels = '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
			} else {
				product_labels += ' <span class="ProductItem__Label ProductItem__Label--soldOut Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}

			var product_created_date = new Date(data.created_at);
			var current = new Date();
			var seconds = Math.abs(current.getTime() - product_created_date.getTime()) / 1000;
    		var days = parseInt(((seconds / 60) / 60) / 24);
			var newLabel = "";
			if (days <= 150) { newLabel = `<span class="ProductItem__Label Heading Text--subdued gray__label">New</span>`; }
			if (product_labels != '' || newLabel != '' || bestSeller != '' || iconic != '') {
				html += '<div class="ProductItem__LabelList">';
				
				if(product_labels !=""){
					html += product_labels
				} else if ( bestSeller != '' || iconic != ''){
					html += bestSeller;
					html += iconic;
				}
				else if ( newLabel != ''){
					html += newLabel;
				}
				 

				html += '</div>';
			}
		}
		return html;
	}

	function buildInfo(data, indx) {
		var html = '';
      var is_option_available = false;
			if(jQuery.inArray("finish", data.options) !== -1) {
				is_option_available = true;
			} else if(jQuery.inArray("color", data.options) !== -1) {
				is_option_available = true;				
			} else if(jQuery.inArray("Color", data.options) !== -1) {
				is_option_available = true;
			} else if(jQuery.inArray("Finish", data.options) !== -1) {
				is_option_available = true;
			}
		if (boostPFSThemeConfig.custom.show_product_info) {
			html += '<div class="product--info-wrapper">';
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + escapeHtml(data.vendor) + '</p>'
			}

			html += '<h2 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + escapeHtml(data.title) + '<span class="ProductItem--vendor">By ' + escapeHtml(data.vendor) + '</span></a>';
			if (is_option_available) {
				html += '<span class="option_available">+ Options</span>';	
			}
          
          html += '</h2>';        
			html += '{{itemReviews}}';
			var callForPrice = (data.metafields || []).some(function(field) {
				return field.key === 'call-for-price' && (!field.namespace || field.namespace === 'global') && String(field.value).toLowerCase() === 'yes';
			});
			if (callForPrice) {
				html += '<span class="ProductItem__Price Price Text--subdued call-for-price">Request Pricing</span>';
			} else {
				html += buildPrice(data,is_option_available);
			}
          
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx, is_option_available);	
			}

			
			
			html += '</div>';
			html += '<div class="ProductItem__SecondColumn">';
			html += '<p class="ProductItem__Vendor Heading">By ' + escapeHtml(data.vendor) + '</p>';
			html += '</div></div>';
		}

		return html;
	}

	function buildSwatch(data, indx) {
		var itemSwatchHtml = '';
		if (boostPFSThemeConfig.custom.show_color_swatch) {
		var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
		data.options_with_values.forEach(function (option, index) {
			var option_name = option.name.toLowerCase();
			if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
			var values = '';
			itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
			var i = 0;
			data.variants.forEach(function (variant) {
				var temp = variant.merged_options.filter(function (obj) {
					obj = obj.toLowerCase();
					if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
						return obj;
				});
				temp = temp[0].split(':');

				var value = temp[1].toLowerCase();
				if (values.indexOf(value) == -1) {
					values = values + ',' + value;
					values = values.split(',');
					var size = '200,400,600,700,800,900,1000,1200';
					var supported_sizes = imageSize(size, variant.image);
					var color_image = Utils.optimizeImage(variant.image);
					var name_color = Utils.slugify(value) + '.png';
					var checked = (i == 0) ? 'checked=checked' : '';
					var imageInfo = null;
					var image_aspect_ratio = 1;
					imageInfo = data.images_info.find(function (imageOb) {
						if (imageOb.src == variant.image){
							image_aspect_ratio = imageOb.width / imageOb.height;
						return imageOb;
						} 
					});
					if (!imageInfo){
						if (data.images_info.length > 0){
							imageInfo = data.images_info[0];
						} else {
							imageInfo = {
							src: boostPFSConfig.general.no_image_url,
								id: variant.id,
								width: 480,
								height: 480
							}
						}
						
					}
					var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
					var color_input_id = color_name + "-" + values.length;
					var variant_price = variant.price ? variant.price : 0;
					var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
					var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
					itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
					itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
					itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
					itemSwatchHtml += '</div>';
					i++;
				}
			});
			itemSwatchHtml += '</div>';
			}
		});
		}
		return itemSwatchHtml;
	}



	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct

		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};


	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {

				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};


	ProductSorting.prototype.bindEvents = function() {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').on('click', function(e) {
			var option = jQ(this);
			FilterApi.setParam('sort', option.data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			option.addClass('is-selected').siblings('.Popover__Value').removeClass('is-selected');
			afterPaint(function() {
				jQ('.CollectionToolbar__Item--sort').trigger('click');
			});
		});
	}



	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;


		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").off('click.collectionSwatch').on('click.collectionSwatch', function() {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})


		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/'+ mobileView + '--phone');
		}
	};

	Filter.prototype.afterRender = function() {
		var error = document.querySelector('[data-collection-error]');
		if (error) error.remove();
		normalizeFilterLabels();
	};

	var addressBarPending = false;
	var updateAddressBar = Navigation.updateAddressBar;
	var setFilterData = Filter.prototype.setData;

	function afterPaint(callback) {
		var done = false;
		function run() {
			if (done) return;
			done = true;
			callback();
		}
		requestAnimationFrame(function() { setTimeout(run, 0); });
		setTimeout(run, 250);
	}

	function flushAddressBar() {
		if (!addressBarPending) return;
		addressBarPending = false;
		updateAddressBar.call(Navigation);
	}

	Navigation.updateAddressBar = function() {
		if (addressBarPending) return;
		addressBarPending = true;
		afterPaint(flushAddressBar);
	};

	Filter.prototype.setData = function() {
		try {
			flushAddressBar();
		} catch (error) {}
		return setFilterData.apply(this, arguments);
	};

	window.addEventListener('pagehide', flushAddressBar);

    var lastFilterEventType = 'init';
    var lastFilterEventInfo;
    var getFilterData = FilterApi.getFilterData;

    FilterApi.getFilterData = function(eventType, callback, errorCallback) {
      if (eventType === 'history' && typeof errorCallback !== 'function') {
        errorCallback = function() {
          var filter = BoostPFS.instance && BoostPFS.instance.filter;
          if (filter) filter.errorFilterCallback();
        };
      }
      return getFilterData.call(this, eventType, callback, errorCallback);
    };


    FilterApi.beforeCall = function(eventType, eventInfo) {
      lastFilterEventType = eventType;
      lastFilterEventInfo = eventInfo;

      var hiddenOptions = ["testvv"];
      Globals.queryParams.h_options = hiddenOptions;


    }


	Filter.prototype.errorFilterCallback = function() {
		if (this.filterLoadingIcon) this.filterLoadingIcon.setShow(false);
		var grid = document.querySelector(Selector.products);
		if (!grid || !grid.parentNode) return;
		var error = document.querySelector('[data-collection-error]');
		if (!error) {
			error = document.createElement('div');
			error.className = 'Alert Alert--error';
			error.setAttribute('data-collection-error', '');
			error.setAttribute('role', 'alert');
			error.innerHTML = '<p></p><button class="Link Link--secondary" type="button">Try again</button>';
			error.querySelector('button').addEventListener('click', function() {
				this.disabled = true;
				FilterApi.applyFilter(lastFilterEventType, lastFilterEventInfo);
			});
			grid.parentNode.insertBefore(error, grid);
		}
		error.querySelector('p').textContent = grid.querySelector('.ProductItem') ? 'Products could not be updated. Showing the previous results.' : 'Products could not be loaded.';
		error.querySelector('button').disabled = false;
		grid.querySelectorAll('.CollectionGrid__Skeleton').forEach(function(placeholder) { placeholder.remove(); });
	};
})();
